<h1 matDialogTitle>Unapplied Account Payment</h1>

<mat-dialog-content>
  <ng-container *ngIf="customer; else loading">
    <div>
      <table style="width: 100%;">
        <tr>
          <th class="th-label">Customer Code</th>
          <td class="td-value" style="text-align: right;">{{customer.customerCode}}</td>
        </tr>
        <tr>
          <th class="th-label">Customer Name</th>
          <td class="td-value" style="text-align: right;">{{customer.customerName}}</td>
        </tr>
        <tr>
          <th class="th-label">Balance (Acc.)</th>
          <td class="td-value" style="text-align: right;">{{customer.customerBalance | number:'1.2-2'}}</td>
        </tr>

      </table>
    </div>
    <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" [paymentType]="'ACCOUNT'"
      [amountOutstanding]="0" [customerCode]="customer.customerCode">
    </app-pos-capture-payment>
  </ng-container>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button [disabled]="!formValid || busy" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
